import React from 'react';
import { TrendingUp, TrendingDown, Coins } from 'lucide-react';
import { formatAmount, getContactFromTransaction } from '../utils/format';

const TransactionItem = ({ transaction, onClick, showAccount = false, accountName = '' }) => {
  const isLoan = transaction.type === 'loan' || transaction.type === 'settlement';
  const amount = parseFloat(transaction.amount) || 0;
  const expenseAmount = parseFloat(transaction.expenseAmount) || 0;

  // Determine if negative
  let isNegative = false;
  if (transaction.type === 'transfer') {
    isNegative = false;
  } else if (transaction.type === 'income') {
    isNegative = false;
  } else if (transaction.type === 'loan') {
    isNegative = amount < 0;
  } else if (transaction.type === 'settlement') {
    isNegative = true;
  } else if (transaction.type === 'expense') {
    isNegative = true;
  } else {
    isNegative = expenseAmount > 0;
  }

  const displayAmount = Math.abs(amount);
  const contact = isLoan ? getContactFromTransaction(transaction) : null;

  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-xl p-4 shadow-sm flex justify-between items-center hover:bg-gray-50 transition"
    >
      <div className="flex items-center space-x-3 flex-1">
        {isLoan ? (
          <div className="bg-amber-100 p-2 rounded-full">
            <Coins className="w-4 h-4 text-amber-600" />
          </div>
        ) : isNegative ? (
          <div className="bg-red-100 p-2 rounded-full">
            <TrendingDown className="w-4 h-4 text-red-600" />
          </div>
        ) : (
          <div className="bg-green-100 p-2 rounded-full">
            <TrendingUp className="w-4 h-4 text-green-600" />
          </div>
        )}
        <div className="text-left flex-1">
          <p className="font-medium text-gray-800">{transaction.description}</p>
          <div className="flex items-center gap-2 flex-wrap">
            <p className="text-xs text-gray-500">{transaction.date}</p>
            {showAccount && accountName && accountName !== 'Unknown' && (
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                {accountName}
              </span>
            )}
          </div>
          {transaction.type === 'transfer' && transaction.fromAccount && transaction.toAccount && (
            <p className="text-xs text-indigo-600 mt-1">
              {transaction.fromAccount.name} → {transaction.toAccount.name}
            </p>
          )}
          {isLoan && contact && (
            <p className="text-xs text-amber-600 mt-1">{contact}</p>
          )}
          {transaction.tags && <p className="text-xs text-purple-600 mt-1">{transaction.tags}</p>}
        </div>
      </div>
      <p className={`font-bold text-lg ${isNegative ? 'text-red-600' : 'text-green-600'}`}>
        {isNegative ? '-' : '+'}${formatAmount(displayAmount)}
      </p>
    </button>
  );
};

export default TransactionItem;
